import type { TripItemWithLabels } from '@ultimate-checklist/shared';

/**
 * Packed progress for a set of trip items. "Packed" = status 'done'. Shared by the
 * Trip Overview and the trips list so both count identically.
 */
export function tripProgress(items: Pick<TripItemWithLabels, 'status'>[]): {
  done: number;
  total: number;
  remaining: number;
} {
  const total = items.length;
  const done = items.filter((item) => item.status === 'done').length;
  return { done, total, remaining: total - done };
}
